<div class="flex flex-col gap-4 mb-4 pb-4 border-b border-mg-gray-light">
  @if (!esEliminar && dynamicLabel) {
    <p class="text-sm font-semibold text-mg-main-blue-dark m-0" [innerHTML]="dynamicLabel"></p>
  }

  <div class="flex flex-col gap-1">
    @if (!esEliminar) {      
      <div class="flex items-center gap-4">
        <mg-time
          class="flex-1"
          [withLabel]="true"
          label="Hora"
          [withIcon]="false" customStyle="text-mg-main-blue" mode="update"
          [showErrors]="true" [autocomplette]="false" [required]="true"
          [inputControl]="accionForm.get('sHour') | formTransform:'formControl'"
        ></mg-time>
      </div>

      @if (!isToday) {
        <div class="flex items-center gap-2 ml-1 mt-1">
          <mat-checkbox
            color="primary"
            [checked]="isNextDay"
            (change)="onNextDayToggle($event.checked)">
            <span class="text-xs font-medium text-mg-gray-dark select-none">
              Aplica para el día siguiente
            </span>
          </mat-checkbox>
        </div>
      }
    }

    @if (horaError && !esEliminar) {
    <div class="flex items-start gap-2 bg-red-50 bg-mg-red-light rounded-lg px-3 py-2 mt-1">
      <mg-icon iconName="error" iconClass="text-sm text-mg-red-dark leading-tight mt-0.5"></mg-icon>
      <span class="text-xs text-mg-red-dark leading-snug" [innerHTML]="horaError"></span>
    </div>
    }
  </div>

  <mg-input-select
    label="Motivo de la solicitud"
    placeholder="Selecciona un motivo"
    [required]="true"
    mode="update"
    [aOpciones]="reasonOptions"
    [inputControl]="reasonCodeControl"
  ></mg-input-select>

  @if (requiresExplanation) {
    <mg-input-textarea
      label="Explicación del motivo"
      placeholder="Describe el motivo..."
      [required]="true"
      mode="update"
      [maxlength]="explicacionMaxLength"
      [minlength]="15"
      [minRows]="3"
      [maxRows]="5"
      [inputControl]="explicacionControl"
    ></mg-input-textarea>
  }

  <div class="flex gap-3">
    <button (click)="onCancel()"
      class="flex-1 border border-mg-gray-light text-mg-gray rounded-xl py-2.5 text-sm font-medium hover:bg-gray-50 transition-colors">
      Cancelar
    </button>
    <button (click)="onSave()"
      [disabled]="(esEliminar ? (reasonCodeControl.invalid || (requiresExplanation && explicacionControl.invalid)) : (accionForm.invalid || reasonCodeControl.invalid || (requiresExplanation && explicacionControl.invalid))) || !!horaError"
      class="flex-1 bg-mg-green text-white rounded-xl py-2.5 text-sm font-semibold hover:opacity-90 transition-opacity disabled:opacity-40">
      Agregar Acción
    </button>
  </div>
</div>